import { Link } from "react-router-dom";
import { Seo } from "@/components/site/Seo";

export default function NotFound() {
  return (
    <section className="max-w-7xl mx-auto px-6 md:px-12 py-32 space-y-6" data-testid="not-found">
      <Seo title="Page not found" noindex />
      <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight">Page not found</h1>
      <p className="text-stone-600">The page you are looking for does not exist.</p>
      <Link to="/" className="inline-block rounded-full bg-emerald-900 text-white px-6 py-3" data-testid="not-found-home-btn">Back to home</Link>
    </section>
  );
}
